import React from "react";

const ImagePlaceholder: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    {...props}
  >
    <rect width="40" height="40" rx="8" fill="#F3F4F6"/>
    <rect x="8" y="24" width="24" height="8" rx="2" fill="#E0E0E0"/>
    <circle cx="14" cy="18" r="3" fill="#E0E0E0"/>
    <path d="M8 32L16 24L24 32L32 24" stroke="#BDBDBD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <text x="20" y="15" textAnchor="middle" fill="#BDBDBD" fontSize="10" fontFamily="Arial" dy=".3em">
      No Image
    </text>
  </svg>
);

export default ImagePlaceholder;